import React from "react";
import { ButtonExtraCount } from "@components/button";

// moved here from TableView.utils to prevent import cycles caused by importing from the .styles file
export const getConfirmationActionText = (action: string, count: number, useBoldCount = false): React.ReactElement => (
        <>
            {action}
            <ButtonExtraCount _isBold={useBoldCount}>/{count}/</ButtonExtraCount>
        </>
);